/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Channel_ExwInputs */

const en_price_channel_exw = /** @type {(inputs: Price_Channel_ExwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex works`)
};

/**
* | output |
* | --- |
* | "Ex works" |
*
* @param {Price_Channel_ExwInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_channel_exw = /** @type {((inputs?: Price_Channel_ExwInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Channel_ExwInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_channel_exw(inputs)
});